import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { InvoiceRecord } from '../entities/records';
import * as selectors from '../entities/Invoice/selectors';

function mapStateToProps(state, { invoiceIds }) {
  return {
    invoices: selectors.invoicesByIds(state, invoiceIds),
  };
}

export default compose(
  setPropTypes({
    invoiceIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    invoices: PropTypes.arrayOf(PropTypes.instanceOf(InvoiceRecord)),
  }),
)(mapStateToProps);
